import React, { memo, useEffect } from "react";

import { setDangerousHtml, parseHtmlText, chunk, getClass } from "src/utils";
import { Icon, Stars } from "src/primitives";
import { CustomComponent as CCPlaceholder } from "src/component-placeholders";
import { Load } from "src/component-loader";
import { useStore } from "src/store";
import Pagination from "../../Pagination";
// import {ClarityScript} from 'src/components/ClarityScripts';
import styles from "./style.css";
import {SPONSORED_ADS_PROVIDER_IDS} from "../../../utils/constants";
import {useTranslation} from "react-i18next";
const clickEvent = new Event("searchAdClick", { bubbles: true });

const clickNotify = ({ dataClickNotify, dataClickNotify1 }, otherParams) => e => {
  const { targetWindow, contentType, variant } = otherParams
  e.stopPropagation();
  e.preventDefault();
  e.target.dispatchEvent(clickEvent);

  dataClickNotify && fetch(dataClickNotify);
  dataClickNotify1 && fetch(dataClickNotify1);

  if (contentType === 'organic' && window.gtag) {
    window.gtag('event', 'click', {
      content_type: contentType,
      variant: variant
    })
  }
  targetWindow === '_blank' ? window.open(e.target.href, targetWindow) : (e.target.href && setTimeout(() => (window.location.href = e.target.href), 400));
};

const GenericItem = memo(props => {
  const { title, description, domain, aside, url, clickUrl, children, ...rest } = props.item;
  const otherParams = { targetWindow: props.targetWindow, contentType: props.contentType, variant: props.variant };
  const sponsoredSearchResults2 = props.sponsoredSearchResults2;
  let titleColor, titleFontSize, siteColor, siteFontSize, descriptionColor, descriptionFontSize;
  if (sponsoredSearchResults2?.active && otherParams.contentType === 'organic') {
    // Overwrite styles
      titleColor = sponsoredSearchResults2[`ssr3${sponsoredSearchResults2.sponsoredSearchResults2Style}TitleFontColor`]
      titleFontSize = sponsoredSearchResults2[`ssr3${sponsoredSearchResults2.sponsoredSearchResults2Style}TitleFontSize`]
      siteColor = sponsoredSearchResults2[`ssr3${sponsoredSearchResults2.sponsoredSearchResults2Style}SiteFontColor`]
      siteFontSize = sponsoredSearchResults2[`ssr3${sponsoredSearchResults2.sponsoredSearchResults2Style}SiteFontSize`]
      descriptionColor = sponsoredSearchResults2[`ssr3${sponsoredSearchResults2.sponsoredSearchResults2Style}DescriptionFontColor`]
      descriptionFontSize = sponsoredSearchResults2[`ssr3${sponsoredSearchResults2.sponsoredSearchResults2Style}DescriptionFontSize`]
  }
  return (
    <article class={styles.genericItem} data-af-component={props["data-af-component"] || ""}>
      <div>
        <a ref={setDangerousHtml(title)} style={{color: titleColor || '', fontSize: titleFontSize || ''}} href={url || clickUrl} onClick={clickNotify(rest, otherParams )} />
        <span ref={setDangerousHtml(domain)} style={{color: siteColor || '', fontSize: siteFontSize || ''}} />
        <div ref={setDangerousHtml(description)}  style={{color: descriptionColor || '', fontSize: descriptionFontSize || ''}}  />
        <div>{children}</div>
      </div>
      {aside && <aside>{aside}</aside>}
    </article>
  );
});

const TargetingScriptSnippet = memo(props => {
  const { targetingScript } = props;
  return <div ref={targetingScript ? setDangerousHtml(decodeURIComponent(targetingScript)) : {}} />;
});
const HotjarSyndicationScriptSnippet = memo(props => {
  const { hotjarSyndicationScript } = props;
  return <div ref={hotjarSyndicationScript ? setDangerousHtml(decodeURIComponent(hotjarSyndicationScript)) : {}} />;
});

export const OrganicItem = memo(props => <GenericItem {...props} />);

const AdItem = memo(props => {
  const {
    url,
    deeplinks = [],
    callExtension: cext = {},
    meteredCallExtension: mcext = {},
    smartExtension: smext = {},
    merchantRatingExtension: mrext = {},
  } = props.item; // hotfix: logic for sponsoredSearchResults2 props can be improved

  return (
    <GenericItem
      {...props}
      url={url}
      data-af-component="Search-Results-AdItem"
      aside={
        <a class={styles.adItemIcon} href={url} onClick={clickNotify(props.item)}>
          <Icon name="chevron_right" />
        </a>
      }
    >
      {mrext && mrext.rating ? (
        <div class={styles.adMerchantRating}>
          {mrext.domain} is rated <Stars starWidth={12} rating={mrext.rating / 2} />{" "}
          <a href={mrext.ratingLink} onClick={clickNotify(mrext)}>
            {mrext.numberOfRatings} reviews
          </a>
        </div>
      ) : null}
      {smext && smext.sidebarEntities && <div ref={setDangerousHtml(smext.sidebarEntities)} />}
      {mcext
        ? (mcext.normalizedPhoneNumber || mcext.provisionedPhoneNumber) && (
            <a href={`tel:${mcext.normalizedPhoneNumber || mcext.provisionedPhoneNumber}`} onClick={clickNotify(mcext)}>
              FREE: {mcext.normalizedPhoneNumber || mcext.provisionedPhoneNumber}
            </a>
          )
        : cext &&
          cext.phoneNumber && (
            <a href={`tel:${cext.phoneNumber}`} onClick={clickNotify(mcext)}>
              {cext.phoneNumber}
            </a>
          )}
      {deeplinks.length > 0 ? (
        <div class={styles.adItemLinks}>
          {chunk(deeplinks, 2).map((row, i) => (
            <div key={i}>
              {row.map((l, j) => (
                <a key={j} href={l.url} ref={setDangerousHtml(l.title)} onClick={clickNotify(l)} />
              ))}
            </div>
          ))}
        </div>
      ) : null}
    </GenericItem>
  );
});

const RelatedItem = memo(props => {
  const { text, displayText } = props.item;

  return <article class={styles.relatedItem} ref={setDangerousHtml(displayText)} onClick={() => props.submitSearch(text)} />;
});

const adDetails = (tranlate) => ({
  header: ({ qctx }) => (
      <header>
        {tranlate('Home.Ads related to')}<strong>{qctx.originalQuery}</strong>
      </header>
  ),
  component: AdItem
})

export const contentDetails = (translate) => ({
  organic: { header: translate('Search.Web Results'), component: OrganicItem },
  topAds: adDetails(translate),
  bottomAds: adDetails(translate),
  sponsoredYasabeAds: adDetails(translate),
  related: { header: translate('Search.Related Searches'), component: RelatedItem }
});

const hasContentForCLientSideAds = (content) => {
  if (content.length) {
    for (let i = 0; i < content.length; i++) {
      if (content[i].name === 'bingSyndicationJS' && Object.keys(content[i].value).length) {
        return true;
      }
    }
  }
  return false;
}

const ResultsSERP = memo(props => {
  const { submitSearch, results = {}, organicNewsResult } = props;
  const { resultsCount = 0, adCount, impressionUrl, sponsoredAdsImpressionUrl, queryContext = {}, content = [], viewProperties } = results;
  const store = useStore(["config", "children", "loadedAds"]);
  const hasBingSyndicationJS = hasContentForCLientSideAds(content);
  const { targetingScript = "", hotjarSyndicationScript = "" } = store("config");
  const { haveAdsLoaded = false } = store("loadedAds") || {};
  const { t: translator } = useTranslation();
  // const clarityScripts = store("children").find(item => item.name === 'clarityScripts')
  let googleCSEComponent = {};
  let googleRKWComponent = {};
  let googleCustomSearchAdParams;

  if (store("children").length > 0) {
    store("children").forEach(item => {
      if (item.name === "serpLayout") {
        googleRKWComponent = JSON.parse(item.props.serpLayout).find(
            component => component.name === "googleRelatedKeywords" && component.enabled === true && component.active === true
        );
        googleCSEComponent = JSON.parse(item.props.serpLayout).find(
            component => component.name === "googleCustomSearch" && component.enabled === true && component.active === true
        );
      }
    })
  }

  const sponsoredSearchResults2 = props.serpLayout.find(serp => serp.name == "sponsoredSearchResults2");

  useEffect(() => {
    impressionUrl && fetch(impressionUrl);
    sponsoredAdsImpressionUrl && fetch(sponsoredAdsImpressionUrl);
  }, [impressionUrl, sponsoredAdsImpressionUrl]);

  if (viewProperties) {
    googleCustomSearchAdParams = viewProperties?.SERPCustomCode.find(c => c.name === "sponsoredSearchResults2");
    googleCustomSearchAdParams = googleCustomSearchAdParams?.customCode ? googleCustomSearchAdParams.customCode : null;
  } else if (content){
    googleCustomSearchAdParams = content.filter(c => c.name === "sponsoredSearchResults2").map(filteredContent => filteredContent?.value);
    googleCustomSearchAdParams = googleCustomSearchAdParams[0]?.customCode ? googleCustomSearchAdParams[0].customCode : null;
  }
  const gcseLanguage = sponsoredSearchResults2?.gcseLanguage || 'en';
  let parsedParams = {};

  if (googleCustomSearchAdParams) {
      try {
          parsedParams = JSON.parse(googleCustomSearchAdParams);
      } catch (e) {
          console.log('Error parsing googleCustomSearchAdParams');
      }
  }

  parsedParams.hl = gcseLanguage;
  googleCustomSearchAdParams = JSON.stringify(parsedParams);

  const hasRelatedContent = content.find(c => c.name === "related" && c.value && c.value.items && c.value.items.length);
  const hasOrganicSearchResults = props.serpLayout.find(serp => serp.name == "OrganicSearchResults" && serp.enabled);
  const relatedKeywordsPosition = props.serpLayout.find(x => x.name == 'RelatedKeywords')?.relatedKeywordsPosition;

  const hasSponsoredSearchResults2 = props.serpLayout.find(serp => serp.name == "sponsoredSearchResults2");
  const isSponsoredOnly = !hasRelatedContent && !hasOrganicSearchResults && hasSponsoredSearchResults2 && hasSponsoredSearchResults2.enabled === true;

    return !hasSponsoredSearchResults2 && !resultsCount && !adCount && !hasBingSyndicationJS ? (
    <div class={styles.noResults}>
      <strong>Your search {queryContext.originalQuery} did not return any results.</strong>
      <br />
      Please use different keywords and try again.
      <TargetingScriptSnippet targetingScript={targetingScript} />
      <HotjarSyndicationScriptSnippet hotjarSyndicationScript={hotjarSyndicationScript} />
    </div>
  ) : (
    <div>
      <div class={getClass(styles.container, hasRelatedContent && relatedKeywordsPosition === "Sidebar" && styles.containerRelated) + ' override__900'}>
        {hasSponsoredSearchResults2 && props.serpLayout ? props.serpLayout.map((c) => {
          const { name, active, value = {} } = c;
          if (name === "sponsoredSearchResults2" && active) {
            return (
              <Load
                {...value}
                {...c}
                googleCustomAdsParams={googleCustomSearchAdParams}
                searchParams={props.searchParams}
                data={props.searchParams.bingOneCall ? props.results : {}}
                isSponsoredOnly={isSponsoredOnly}
                paginationEnabled={props.paginationEnabled}
                results={results}
                name="sponsoredApiAds"
                key={name}
              />
            );
          }
        }) : null}

        {content.map((c, i) => {

          const { name, value = {} } = c;
          if (name && (name.indexOf("serpCustomComponent") > -1 || name.indexOf("bingSyndicationJS") > -1) && value.customCode && value.customCode.length > 1) {
            return <CCPlaceholder template={value.customCode}  key={name} ></CCPlaceholder>;
          }

          if (name === "adUnit") {
            return <Load {...value} name="adUnit"  key={name} />;
          }

          if(name === 'newsFeed'){
            const isActive = props.serpLayout.find(i => i.name == 'newsFeed').active;
            return isActive ? (
            <Load serpLayout={props.serpLayout} showMoreNewsLink={true} name="News"/>
            ) : null;
          };

          if (name === "googleCustomSearch" && googleCSEComponent?.googleCSEDefaultSearchId) {
            return <Load googleCSEDefaultSearchId={googleCSEComponent.googleCSEDefaultSearchId} name="GoogleCustomSearch"  key={name} />;
          }

          if (name === "googleRelatedKeywords" && googleRKWComponent) {
            return <Load
              grkStyleId={googleRKWComponent?.grkStyleId}
              grkType={googleRKWComponent?.grkType}
              grkMaxNumberOfKeywords={googleRKWComponent?.grkMaxNumberOfKeywords}
              grkLandingPage={googleRKWComponent?.grkLandingPage}
              grkCode={googleRKWComponent?.grkCode}
              grkPubId={googleRKWComponent?.grkPubId}
              grkLanguage={googleRKWComponent?.grkLanguage || 'en'}
              name="GoogleRelatedKeywords"
              googleRelatedComponents={[googleRKWComponent]}
              key={name}
            />;
          }

          if (name === "topCode" || name === "bottomCode") {
            return (
              <div  key={name} >
                <div ref={setDangerousHtml(value.code)} />
                <div ref={setDangerousHtml(value.customCode)} />
              </div>
            );
          }

          if (name === "banner") {
            return (
              <a class={styles.banner} href={value.clickUrl}  key={name} >
                <img src={value.imgSource} height={`${value.size.height}px`} width={`${value.size.width}px`} />
              </a>
            );
          }

          if (name === "videos") {
            const { items = [] } = value;

            return items.length ? (
              <section class={styles.videoItems}>
                <header>Videos</header>
                <div>
                  {items.map(v => (
                    <a key={v.contentUrl} href={v.contentUrl}>
                      <img src={v.thumbnailUrl} />
                      <header>{parseHtmlText(v.name)}</header>
                      <footer>
                        {v.publisher}
                        <small> - {v.duration}</small>
                      </footer>
                    </a>
                  ))}
                </div>
              </section>
            ) : null;
          }

          if (name === "images") {
            const { items = {} } = value;
            const { top = [], bottom = [] } = items;

            return top.length + bottom.length ? (
              <section class={styles.imageItems}>
                <header>Images</header>
                <div>
                  <div>
                    {top.map(t => (
                      <a key={t.contentUrl} href={t.contentUrl}>
                        <img src={t.thumbnailUrl} />
                      </a>
                    ))}
                  </div>
                  <div>
                    {bottom.map(b => (
                      <a key={b.thumbnailUrl} href={b.contentUrl}>
                        <img src={b.thumbnailUrl} />
                      </a>
                    ))}
                  </div>
                </div>
              </section>
            ) : null;
          }

          if (name === "OrganicNewsResults") {
            const organicNews = props.serpLayout.find(i => i.name == 'OrganicNewsResults');
            if(organicNews && organicNews.active && (haveAdsLoaded || !hasSponsoredSearchResults2?.active)) {
              return <Load {...value} {...c} searchParams={props.searchParams} organicNewsResult={organicNewsResult} name="organicNewsResult"  key={name} />;
            }
          }

          const { items = [] } = value;
          const details = contentDetails(translator)[name];
          const { targetWindow = "" } = sponsoredSearchResults2 || {};

          return details && items.length > 0 && (haveAdsLoaded || !hasSponsoredSearchResults2?.active || name === 'organic' || name === 'related') ? (
            <section key={i} id={name + "CtrlId"} class={getClass(name === "related" && (styles[relatedKeywordsPosition] || styles.relatedItems) )}>
                {typeof details.header === "function" ? <details.header qctx={queryContext} /> : <header>{details.header}</header>}
                {items.map((item, j) => (
                  <details.component key={j} {...{sponsoredSearchResults2, item}} targetWindow={targetWindow} submitSearch={submitSearch} contentType={name} variant={props.searchParams.variant} />
                ))}
                {value.customCode ? <div ref={setDangerousHtml(value.customCode)} /> : <div></div>}
              </section>
          ) : null;
        })}
        {/* TODO: To be added in the future, as currently should work only for sponsoredSearchRessults2.*/}
        {/* {clarityScripts?.props && !hasSponsoredSearchResults2 && <ClarityScript {...clarityScripts.props}  />} */}
        {hasSponsoredSearchResults2 && props.serpLayout ? props.serpLayout.map((c) => {
          const { name, active, value = {} } = c;
          if (name === "sponsoredSearchResults2" && active && c.ssrDuplicateResultsBottom) {
            if (props.results && props.results.provider !== SPONSORED_ADS_PROVIDER_IDS.GOOGLE.id) {
              return <Load {...value} {...c} dublicateResults={true} searchParams={props.searchParams} data={props.searchParams.bingOneCall ? props.results : {}} name="sponsoredApiAds"  key={name} />;
            }
          }
        }) : null}
        {(props.paginationEnabled && !isSponsoredOnly) &&
          <Pagination
                submitSearch={(p, direction) => {submitSearch(false,{p, direction})}}
                enablePrevPage={props?.results?.providerPrevArgs}
                provider={props?.results?.provider}
          />}
      </div>
      <TargetingScriptSnippet targetingScript={targetingScript} />
      <HotjarSyndicationScriptSnippet hotjarSyndicationScript={hotjarSyndicationScript} />
    </div>
  );
});

export default ResultsSERP;
